export function personAge(person) {
    if (person?.birthday) {
        if (person?.deathday) {
            function age(birthYear, birthMonth, birthDay) {
                var d = new Date,
                    deathYear = person?.deathday.slice(0, 4),
                    deathMonth = person?.deathday.slice(5, 7),
                    deathDay = person?.deathday.slice(8, 10),

                    birthYear = +birthYear,
                    birthMonth = +birthMonth,
                    birthDay = +birthDay,

                    yearsOld = deathYear - birthYear;

                if (deathMonth < birthMonth || (deathMonth == birthMonth && deathDay < birthDay)) {
                    yearsOld--;
                }

                return yearsOld < 0 ? 0 : yearsOld;
            }
            return (age(person?.birthday.slice(0, 4), person?.birthday.slice(5, 7), person?.birthday.slice(8, 10)));
        } else if (!person?.deathday) {
            function age(birthYear, birthMonth, birthDay) {
                var d = new Date,
                    currentYear = d.getFullYear(),
                    currentMonth = d.getMonth() + 1,
                    currentDay = d.getDate(),

                    birthYear = +birthYear,
                    birthMonth = +birthMonth,
                    birthDay = +birthDay,

                    yearsOld = currentYear - birthYear;

                if (currentMonth < birthMonth || (currentMonth == birthMonth && currentDay < birthDay)) {
                    yearsOld--;
                }

                return yearsOld < 0 ? 0 : yearsOld;
            }
            return (age(person?.birthday.slice(0, 4), person?.birthday.slice(5, 7), person?.birthday.slice(8, 10)));
        }
    }
}
